<template>
    <v-select
        v-if="examples.length > 0"
        @change="exampleClick"
        v-model="selectedExample"
        style="max-width: 15rem"
        :items="examples"
        item-title="title"
        :item-value="(item) => item"
        label="Trial inputs"
        variant="outlined"
        density="compact"
    >
        <template v-slot:item="{ item, props }">
            <v-list-item v-bind="props">
                <v-list-item-title>
                    {{ item.title }}
                </v-list-item-title>
                <v-list-item-subtitle
                    style="
                        -webkit-line-clamp: unset !important;
                        overflow-x: hidden;
                        text-overflow: ellipsis;
                        white-space: unset;
                    "
                >
                    {{ item.description }}
                </v-list-item-subtitle>
            </v-list-item>
        </template>
    </v-select>
</template>
<script setup>
import { ref, watch } from 'vue'

const props = defineProps(['modelValue', 'examples'])
const emit = defineEmits(['update:modelValue'])

const selectedExample = ref(props.modelValue)

watch(
    () => props.modelValue,
    () => {
        selectedExample.value = props.modelValue
    },
    { deep: true }
)

function exampleClick() {
    emit('update:modelValue', selectedExample.value)
}
</script>
